import { render, staticRenderFns } from "./ContLoadBulk.vue?vue&type=template&id=222114a4&scoped=true&lang=pug"
import script from "./ContLoadBulk.vue?vue&type=script&lang=js"
export * from "./ContLoadBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222114a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222114a4')) {
      api.createRecord('222114a4', component.options)
    } else {
      api.reload('222114a4', component.options)
    }
    module.hot.accept("./ContLoadBulk.vue?vue&type=template&id=222114a4&scoped=true&lang=pug", function () {
      api.rerender('222114a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ContLoadBulk.vue"
export default component.exports